import axios from 'axios';

class ChangePasswordServiceClass {
  changePassword(password, passwordResetHash) {
    return axios.post('/api/auth/ResetPasswordWithToken', {
      NewPassword: password,
      Token: passwordResetHash,
    });
  }
}

export const ChangePasswordService = new ChangePasswordServiceClass();
